app.directive("acPipeToScope", ['$rootScope', function($rootScope) {
    return {
        link: function(scope, element, attributes) {
            var key = attributes.acPipeToScope;
            if(key.indexOf(";") != -1){
                var keys = key.split(";")
                keys.forEach(function(newKey){
                    console.log(newKey)
                    scope[newKey] =PTVariablePipe.get(newKey);
                })
            }else{
                scope[key] =PTVariablePipe.get(key);
            }
            
        }
    }
}]);